export enum EmailStatus {
    Created = 10,
    SendFailed = 20,
    Sent = 30,
}

export const enumLabel = (value?: EmailStatus) => {
    switch (value) {
        case EmailStatus.Created:
            return 'Создано';
        case EmailStatus.SendFailed:
            return 'Ошибка отправки';
        case EmailStatus.Sent:
            return 'Отправлено';
        default:
            return '';
    }
};
